import { Header } from '@/components/Base/Header/Header'
import { Navigation } from '@/components/Base/Navigation/Navigation'
import { ModuleTypePageTitle } from '@/enums/axiom-report.enum'
import { IMultiLevelMenu } from '@/interfaces/interfaces'
import { Box } from '@mui/material'
import React from 'react'

export type IStaticReportsLayout = {
  title?: ModuleTypePageTitle | string
  children: JSX.Element
}

const staticReportsdMenu: IMultiLevelMenu = {
  isDownArrow: false,
  heading: 'Reports',
  isMenuList: false,
  route: '/reports',
}

const scenarioBuilderReportsMenu: IMultiLevelMenu = {
  isDownArrow: false,
  heading: ModuleTypePageTitle.SCENARIO_BUILDER,
  isMenuList: false,
  route: '/scenario-builder',
}

const portfolioOptimizationReportsMenu: IMultiLevelMenu = {
  isDownArrow: false,
  heading: ModuleTypePageTitle.PORTFOLIO_OPTIMIZATION,
  isMenuList: false,
  route: '/portfolio-optimization',
}

const portfolioOptimizationRunReportsMenu: IMultiLevelMenu = {
  isDownArrow: false,
  heading: ModuleTypePageTitle.OPTIMIZATION_REPORTS,
  isMenuList: false,
  route: '/optimization-reports',
}

const StaticReportsLayout: React.FC<IStaticReportsLayout> = ({
  title,
  children,
}) => {
  const getHeaderMenuItems = (module: string) => {
    switch (module) {
      case ModuleTypePageTitle.REPORTING:
        return [staticReportsdMenu]
      case ModuleTypePageTitle.SCENARIO_BUILDER:
        return [scenarioBuilderReportsMenu]
      case ModuleTypePageTitle.PORTFOLIO_OPTIMIZATION:
        return [portfolioOptimizationReportsMenu]
      default:
        return []
    }
  }
  const icon = (module: string) => {
    switch (module) {
      case ModuleTypePageTitle.REPORTING:
        // Google Icon Font : Bar Chart
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            height='24px'
            viewBox='0 -960 960 960'
            width='24px'
            fill='#000000'
          >
            <path d='M640-160v-280h160v280H640Zm-240 0v-640h160v640H400Zm-240 0v-440h160v440H160Z' />
          </svg>
        )
      case ModuleTypePageTitle.SCENARIO_BUILDER:
        // Google Icon Font : Flowsheet
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            height='24px'
            viewBox='0 -960 960 960'
            width='24px'
            fill='#000000'
          >
            <path d='M160-480v240-480 240Zm400 360q17 0 28.5-11.5T600-160q0-17-11.5-28.5T560-200q-17 0-28.5 11.5T520-160q0 17 11.5 28.5T560-120Zm240-400q17 0 28.5-11.5T840-560q0-17-11.5-28.5T800-600q-17 0-28.5 11.5T760-560q0 17 11.5 28.5T800-520Zm-560 0h200v-80H240v80Zm0 160h200v-80H240v80Zm-80 200q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720H160v480h200v80H160ZM560-40q-50 0-85-35t-35-85q0-39 22.5-70t57.5-43v-127h240v-47q-35-12-57.5-43T680-560q0-50 35-85t85-35q50 0 85 35t35 85q0 39-22.5 70T840-447v127H600v47q35 12 57.5 43t22.5 70q0 50-35 85t-85 35Z' />
          </svg>
        )
      case ModuleTypePageTitle.PORTFOLIO_OPTIMIZATION:
        // Google Icon Font : Monitoring
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            height='24px'
            viewBox='0 -960 960 960'
            width='24px'
            fill='#000000'
          >
            <path d='M120-120v-80l80-80v160h-80Zm160 0v-240l80-80v320h-80Zm160 0v-320l80 81v239h-80Zm160 0v-239l80-80v319h-80Zm160 0v-400l80-80v480h-80ZM120-327v-113l280-280 160 160 280-280v113L560-447 400-607 120-327Z' />
          </svg>
        )
      default:
        // Google Icon Font : Widgets
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            height='24px'
            viewBox='0 -960 960 960'
            width='24px'
            fill='#000000'
          >
            <path d='M666-440 440-666l226-226 226 226-226 226Zm-546-80v-320h320v320H120Zm400 400v-320h320v320H520Zm-400 0v-320h320v320H120Zm80-480h160v-160H200v160Zm467 48 113-113-113-113-113 113 113 113Zm-67 352h160v-160H600v160Zm-400 0h160v-160H200v160Zm160-400Zm194-65ZM360-360Zm240 0Z' />
          </svg>
        )
    }
  }

  return (
    <Box
      display='grid'
      gridTemplateRows='auto 1fr'
      boxSizing='border-box'
      height='100dvh'
      bgcolor={'#DDE2EB'}
      p={4}
    >
      <Header
        moduleTitle={title ? title : ModuleTypePageTitle.REPORTING}
        moduleIcon={icon(String(title))}
      >
        <Navigation
          headerMenuItems={getHeaderMenuItems(String(title))}
          highlightActive={
            getHeaderMenuItems(String(title))?.length > 1 ? true : false
          }
        />
      </Header>
      <Box
        component='main'
        display='grid'
        p={2}
        borderRadius={2}
        bgcolor='background.default'
        overflow='auto'
      >
        {children}
      </Box>
    </Box>
  )
}

export default StaticReportsLayout
